<template>
<div class="bg-login" style="background:#fff;">

  <!-- Container -->
  <div class="bg-login-main">
    <section class="container">
      <div class="row">
<span style="white-space:pre-wrap; ">
2021/8/31

<strong>新規登録停止のお知らせ</strong>

JSL MeTHODは、アップデートのため、新規登録を停止しております。
再開は2021年10月中旬を予定しております。ご不便をおかけして申し訳ございませんが再開をお待ちいただけますよう宜しくお願い致します。


31st August 2021

<strong>Notice of temporary suspension of registration</strong>

We are suspending new user registrations of JSL MeTHOD for update.
New registrations are expected to resume in mid-October 2021.
We apologize for any inconvenience this may cause you. Thank you for your understanding.



</span>
      </div>
    </section>
    
  </div>
  <div class="bg-login-bottom">
    <div class="container">
      <div class="row bg-login-inner">
        <a href="../" class="button button-primary">{{ $t('common.button.back') }}</a>
      </div>
    </div>
  </div>
  <!-- /Container -->
</div>

</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {api, countrieList} from "../../config";
  
  export default {
    components: {
    },
    data() {
      return {
        loading: false,
      }
    },
    computed: {
    },
    created() {
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>

</style>
